import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d233df0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "not-found-viewport"
};
const _hoisted_2 = {
  class: "icon-pane"
};
const _hoisted_3 = {
  class: "to-home"
};
import { useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {
    const router = useRouter();
    function toHome() {
      router.push({
        path: '/'
      });
    }
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_empty, {
        "image-size": 200,
        description: "您访问了错误的地址或权限不足"
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_link, {
        type: "primary",
        onClick: toHome
      }, {
        default: _withCtx(() => [_createTextVNode("去首页")]),
        _: 1
      })])])]);
    };
  }
});